/* global localStorage */

import HttpRequest from './core/http_request';

class AuthProvider extends HttpRequest {
  login (data) {
    return this.request('POST', '/auth/login', data).then(response => {
      if (response.data.token.accessToken) {
        localStorage.setItem('token', JSON.stringify(response.data.token));
        localStorage.setItem('member', JSON.stringify(response.data.member));
      }
      return response;
    });
  }

  logout () {
    localStorage.removeItem('member');
    localStorage.removeItem('token');
  }

  refreshToken (data) {
    return this.request('POST', '/auth/refresh-token', data);
  }

  register (data) {
    return this.request('POST', '/auth/addmember', data).then(response => {
      if (response?.data?.token?.accessToken) {
        localStorage.setItem('token', JSON.stringify(response.data.token));
        localStorage.setItem('member', JSON.stringify(response.data.member));
      }
      console.log(response);
      return response;
    });
  }

  updatePassword (data) {
    return this.request('POST', '/auth/updatepassword', data);
  }

  requestForgetPassword (data) {
    return this.request('POST', '/auth/requestforgetpassword', data);
  }

  verifyForgetPasswordToken (data) {
    return this.request('post', '/auth/verifyforgetpasswordtoken', data);
  }
}

export default AuthProvider;
